import { css } from "@emotion/react";

export const disabled = css`
	filter: saturate(0.25);
	cursor: not-allowed !important;
`;
